<template>
  <div>
    <div class="stoppage-record" v-if="permission.synchronous" @click="openModal">Listing同步异常记录</div>
    <Modal
      title="Listing同步异常记录"
      v-model="modalVisible"
      width="1220"
      :mask-closable="false"
      :transfer="true"
      class="halt-sales-adjust-modal"
    >
      <div class="modal-main-clas">
        <div class="modal-filter-content">
          <Form ref="modalFilterForm" :model="pageParams" :label-width="60" class="modal-filter-form">
            <Form-item label="SPU" class="modal-filter-item" prop="spuList">
              <dyt-input-tag type="textarea" :limit="1" placeholder="请输入SPU，多个关用逗号或回车分隔" v-model="pageParams.spuList" />
            </Form-item>
            <Form-item label="同步时间" class="modal-filter-item" prop="formTime">
              <DatePicker
                ref="expireDatePicker"
                transfer
                :editable="false"
                style="width: 100%"
                v-model="pageParams.formTime"
                :options="dateOptions"
                placeholder="选择调整时间"
                type="datetimerange"
                format="yyyy-MM-dd HH:mm:ss"
                placement="bottom-end"
              />
            </Form-item>
          </Form>
          <div>
            <Button type="primary" icon="md-search" @click="searchData('init')" :disabled="tableLoading">查询</Button>
            <Button type="primary" class="ml10" @click="exportData" :disabled="exportLoading">导出</Button>
          </div>
        </div>
        <Table
          highlight-row
          border
          :height="500"
          :loading="tableLoading"
          :columns="tableColumn"
          :data="talbeData"
        />
        <div class="mt5 modal-page">
          <Page
            :total="tableTotal"
            @on-change="pageNumChange"
            show-total
            :page-size="pageParams.pageSize"
            show-elevator
            :current="pageParams.pageNum"
            show-sizer
            @on-page-size-change="pageSizeChange"
            placement="top"
            :page-size-opts="pageArray"
          />
        </div>
      </div>
      <div slot="footer">
        <Button @click="modalVisible = false">关闭</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
import api from '@/api/api';

export default {
  name: 'listingSyncAbnormalModal',
  components: {},
  props: {
    moduleData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data () {
    return {
      modalVisible: false,
      loading: false,
      exportLoading: false,
      tableLoading: false,
      pageArray: [10, 20, 50, 100],
      tableTotal: 0,
      pageParams: {
        spuList: [],
        formTime: [],
        pageNum: 1,
        pageSize: 20,
      },
      dateOptions: this.$common.dateOptions(),
      talbeData: [],
      tableColumn: [
        {
          title: 'SPU',
          key: 'spu',
          align: 'center',
          minWidth: 160,
        },
        {
          title: '商品中文名称',
          key: 'cnName',
          align: 'center',
          minWidth: 160,
          render: (h, { row }) => {
            return h('div', {
              style: {
                'display': 'inline-block',
                'margin': '0 auto',
                'text-align': 'left',
              }
            }, row.cnName)
          }
        },
        {
          title: '同步内容',
          key: 'syncType',
          align: 'center',
          minWidth: 160,
          render: (h, { row }) => {
            if (this.$common.isEmpty(row.syncType)) return h('span', '');
            if (this.$common.isEmpty(this.typeObjData[row.syncType])) return h('span', row.syncType);
            return h('span', this.typeObjData[row.syncType].label || row.syncType);
          }
        },
        {
          title: '异常原因',
          key: 'errorInfo',
          align: 'center',
          minWidth: 160,
          render: (h, { row }) => {
            return h('div', {
              style: {
                'display': 'inline-block',
                'margin': '0 auto',
                'text-align': 'left',
              }
            }, row.errorInfo)
          }
        },
        {
          title: '同步时间',
          key: 'syncTime',
          align: 'center',
          minWidth: 160,
          render: (h, { row }) => {
            return h('span', row.syncTime);
          }
        }
      ],
    }
  },
  watch: {
    modalVisible: {
      deep: true,
      handler (val) {
        this.$nextTick(() => {
          !val && this.closeModal();
        })
      }
    }
  },
  computed: {
    // 可查看的事业部
    getUseBusinessDeptIds() {
      if (!this.$store.getters['authUserInfo'] || !this.$store.getters['authUserInfo'].securityUser) return '';
      return this.$store.getters['authUserInfo'].securityUser.businessDeptIds;
    },
    // 权限
    permission () {
      if (this.$common.isEmpty(this.moduleData) || this.$common.isEmpty(this.moduleData.permission)) return {};
      return this.moduleData.permission;
    },
    // 同步内容数据
    typeObjData () {
      if (this.$common.isEmpty(this.moduleData) || this.$common.isEmpty(this.moduleData.typeData)) return {};
      let obj = {};
      this.moduleData.typeData.forEach(item => {
        obj[item.value] = item;
      })
      return obj;
    }
  },
  created () {},
  mounted () {},
  methods: {
    // 初始化数据
    initData () {
      this.$refs.modalFilterForm && this.$refs.modalFilterForm.resetFields();
      this.$nextTick(() => {
        this.searchData('init');
      })
    },
    // 返回搜索条件
    getSearchParams () {
      let obj = this.$common.copy(this.pageParams);
      obj.syncTimeStart = null;
      obj.syncTimeEnd = null;
      if (!this.$common.isEmpty(obj.formTime) && !this.$common.isEmpty(obj.formTime[0])) {
        obj.syncTimeStart = this.$common.toLocaleDate(obj.formTime[0], 'fulltime', 0);
        obj.syncTimeEnd = this.$common.toLocaleDate(obj.formTime[1], 'fulltime', 0);
      }
      delete obj.formTime;
      return obj;
    },
    // 查询列表数据
    searchData (type) {
      if (this.tableLoading) return;
      if (type == 'init') {
        this.pageParams.pageNum = 1;
      }
      let params = this.getSearchParams();
      this.talbeData = [];
      this.tableLoading = true;
      this.axios.post(api.syncListingAbnormalQuery, params).then(res => {
        if (!res || !res.data || !res.data.datas || res.data.code != 0) return;
        this.talbeData = res.data.datas.list || [];
        this.tableTotal = res.data.datas.total;
      }).finally(() => {
        this.tableLoading = false;
      })
    },
    // 导出数据
    exportData () {
      if (this.exportLoading) return;
      let params = this.getSearchParams();
      this.exportLoading = true;
      this.axios.post(api.syncListingAbnormalExport, params).then(res => {
        if (!res || !res.data || res.data.code != 0) return;
        this.$Message.success({
          content: `已生成导出任务，任务编号：${res.data.datas || ''}`,
          duration: 10,
          closable: true
        });
      }).finally(() => {
        this.exportLoading = false;
      })
    },
    // 返回page
    pageNumChange(page) {
      this.pageParams.pageNum = page;
      this.$nextTick(() => {
        this.searchData();
      })
    },
    // 返回pageSize
    pageSizeChange(pageSize) {
      this.pageParams.pageNum = 1;
      this.pageParams.pageSize = pageSize;
      this.$nextTick(() => {
        this.searchData();
      })
    },
    // 打开弹窗
    openModal () {
      this.modalVisible = true;
      this.$nextTick(() => {
        this.initData();
      })
    },
    // 关闭弹窗
    closeModal () {
      this.pageParams.pageNum = 1;
      this.pageParams.pageSize = 20;
      this.talbeData = [];
      this.tableTotal = 0;
      this.exportLoading = false;
      this.tableLoading = false;
      this.loading = false;
    },
  }
};
</script>
<style lang="less" scoped>
.stoppage-record{
  padding-right: 15px;
  color: #03A9F4;
  font-weight: bold;
  line-height: 33px;
  text-decoration: underline;
  text-underline-position: under;
  cursor: pointer;
}
.modal-main-clas{
  position: relative;
  .modal-filter-content{
    position: relative;
    display: flex;
    .modal-filter-form{
      position: relative;
      flex: 100;
      :deep(.modal-filter-item){
        display: inline-block;
        .ivu-form-item-label{
          padding-right: 5px;
        }
        .ivu-form-item-content{
          width: 280px;
        }
      }
    }
  }
  .modal-page{
    :deep(.ivu-page) {
      text-align: right;
    }
  }
}
</style>
<style lang="less">
.halt-sales-adjust-modal {
  .ivu-modal-footer{
    padding-top: 0;
  }
}
</style>
